import alerts from './ALERTS';
import atAGlance from './AT_A_GLANCE';
import bankNotificationCode from './BANK_NOTIFICATION_CODE';
import common from './COMMON';
import employeePays from './EMPLOYEE_PAYS';
import enums from './ENUMS';
import quickActions from './QUICK_ACTIONS';
import bankNotificationCodeEnhanced from './BANK_NOTIFICATION_CODE_ENHANCED';
import staleDatedChecks from './STALE_DATED_CHECKS';
import companies from './COMPANIES';

export default {
  'en-US': {
    ALERTS: alerts['en-US'],
    AT_A_GLANCE: atAGlance['en-US'],
    BANK_NOTIFICATION_CODE: bankNotificationCode['en-US'],
    COMMON: common['en-US'],
    EMPLOYEE_PAYS: employeePays['en-US'],
    ENUMS: enums['en-US'],
    QUICK_ACTIONS: quickActions['en-US'],
    BANK_NOTIFICATION_CODE_ENHANCED: bankNotificationCodeEnhanced['en-US'],
    STALE_DATED_CHECKS: staleDatedChecks['en-US'],
    COMPANIES: companies['en-US']
  },
};
